/*  app/ui/social/instagram-timeline */
define(
	'app/ui/social/instagram-timeline',[
		'jquery'
	],
	function ($) {
		'use strict';
		var InstagramTimeline;

		var token = '1707088048.1677ed0.004031a8150c423d801590605caedf84';//this token for nzwine instagram
		var requestUrl = 'https://api.instagram.com/v1/users/self/media/recent';
		var numPhotos = 9;
		var numShowMobile = 4;
		var accountUrl; //need another ajax call if we want get userUrl from instagram, so get from mark-up attr for convenience

		return {
			init: function() {
				var $timelineInstagram = $('.js-instagram-timeline');
				if ($timelineInstagram.length) {
					require(
						[
							'templayed',
							'text!templates/instagram-timeline.html'
						],
						function(templayed, instaTemplate) {
							// Templayed cannot handle carriage returns
							instaTemplate = instaTemplate.replace(/\r/g, '');
							InstagramTimeline = this;
							var userName;
							var avatarUrl;
							var $instagramWidget = $('#instagram-timeline');
							accountUrl = $instagramWidget.attr('data-user-url');
							$.ajax({
								url: requestUrl,
								dataType: 'jsonp',
								type: 'GET',
								data: { access_token: token, count: numPhotos },
								success: function(data) {
									//console.log(data);
									var templateData = {
										accountUrl: accountUrl,
										accountAvatarUrl: '',
										accountName: '',
										posts: []
									};
									for (var x in data.data) {
										templateData.posts.push({
											hidden: x >= numShowMobile,
											postLink: data.data[x].link,
											postImageUrl: data.data[x].images.low_resolution.url,
											postLikeNum: String(data.data[x].likes.count),
											postCommentNum: String(data.data[x].comments.count)
										});
										if (!userName) {
											userName = data.data[x].user.username;
										}
										if (!avatarUrl) {
											avatarUrl = data.data[x].user.profile_picture;
										}
									}
									templateData.accountAvatarUrl = avatarUrl;
									templateData.accountName = userName;
									$instagramWidget.html(templayed(instaTemplate)(templateData));
								},
								error: function(data) {
									console.error(data);
								}
							});
						}
					);
				}

			}
		};
	}
);
